
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/opp/[opportunityId]",
      function () {
        return require("private-next-pages/opp/[opportunityId].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/opp/[opportunityId]"])
      });
    }
  